module.exports = __webpack_public_path__ + "static/img/zj0.72097ea6.jpg";